import {
  getJsonData,
  postFormData,
} from "../Services/AxoisInterceptorr";

export const createCareer = (
  data,
  setIsProgress,
  onSuccess,
  onError
) => {
  return postFormData(
    "/api/careers",
    data,
    setIsProgress,
    onSuccess,
    onError
  );
};

export const getCareers = (
  setIsProgress,
  onSuccess,
  onError
) => {
  return getJsonData(
    "/api/careers",
    setIsProgress,
    onSuccess,
    onError
  );
};

export const createOperationalRequest = (
  data,
  setIsProgress,
  onSuccess,
  onError
) => {
  return postFormData(
    "/api/operational-requests",
    data,
    setIsProgress,
    onSuccess,
    onError
  );
};

export const getOperationalRequests = (
  setIsProgress,
  onSuccess,
  onError
) => {
  return getJsonData(
    "/api/operational-requests",
    setIsProgress,
    onSuccess,
    onError
  );
};